import con from '../../../../connection';
var path = '/files';
var files = function (url) { return function (fileId) { return ({
    post: function (param, options) { return con.post(url + path, param, options === null || options === void 0 ? void 0 : options.noError, options === null || options === void 0 ? void 0 : options.timeoutMS); },
    delete: function (param, option) { return con.delete(url + path, param, option === null || option === void 0 ? void 0 : option.noError); },
    get: function (param, options) { return con.getFile(url + path + '/' + fileId, param, options === null || options === void 0 ? void 0 : options.noError); }
}); }; };
export default files;
